import { render, staticRenderFns } from "./NhlNews.vue?vue&type=template&id=71557817&scoped=true"
import script from "./NhlNews.vue?vue&type=script&lang=js"
export * from "./NhlNews.vue?vue&type=script&lang=js"
import style0 from "./NhlNews.vue?vue&type=style&index=0&id=71557817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71557817",
  null
  
)

export default component.exports